export function SpecialSituations() {
  return (
    <section
      className="w-full flex items-center justify-center py-20 bg-blue-100/15 mt-40"
      id="special"
    >
      <div className="w-full flex flex-col max-w-[1400px] items-center justify-center">
        <h2 className="text-4xl font-bold text-blue-200">Special Situations</h2>
        <p className="text-lg font-medium text-blue-200 mt-8 max-w-[80%]">
          O mercado de investimentos tradicional oferece diversas opções, mas
          muitas vezes os retornos podem ser limitados e os riscos,
          consideráveis. A Simya Capital acredita que o futuro dos investimentos
          está na exploração de novas fronteiras, em ativos fora do circuito
          tradicional, que podem gerar valor significativo para o seu portfólio.
          <br />
          <br />
          Atuando nesse mercado de ativos não convencionais, também conhecido
          como Special Situations, a Simya Capital oferece consultoria,
          intermediação e possibilidades de investimento em ativos estressados.
          <br />
          <br />
          As oportunidades estão diretamente relacionadas a grandes passivos
          financeiros, processos falimentares e de recuperação judicial, ou
          segmentos alternativos, com opções que envolvem maior grau de risco.
          <br />
          <br />
          Por tais motivos, nossa estratégia é composta pela análise detalhada
          dos casos, verificando os riscos e assimetrias de informação, buscando
          a melhor precificação do ativo e atuando de forma transparente e ética
          perante o cliente e os stakeholders envolvidos.
        </p>
      </div>
    </section>
  );
}
